import { formatDate } from 'helpers/helpers'

export const STATUS_DISPOSED = 0
export const STATUS_ACTIVE = 1
export const STATUS_CONSERVED = 2

// Статус — заливкой всей ячейки, как в остальных таблицах кабинета
export function statusClass(status) {
	if (status === STATUS_CONSERVED) return 'bg-warning text-white'
	if (status === STATUS_DISPOSED) return 'bg-secondary text-white'
	return 'bg-success text-white'
}

export function statusLabel(t, status) {
	if (status === STATUS_CONSERVED) return t('fa_status_conserved')
	if (status === STATUS_DISPOSED) return t('fa_status_disposed')
	return t('fa_status_active')
}

// «2026-09-01» → «09.2026»
export function formatPeriod(period) {
	if (!period) return ''
	return formatDate(period, 'MM.yyyy')
}

// Событие можно провести только после последнего начисленного месяца:
// проведённый месяц сервер не переписывает. «2026-09-01» → 1 октября 2026
export function firstOpenDate(schedule = []) {
	const frozen = schedule.filter(row => row.is_frozen)
	if (frozen.length === 0) return null
	const [year, month] = frozen[frozen.length - 1].period.split('-').map(Number)
	return new Date(year, month, 1)
}
